export const userRoutesConfig = [
  {
    method: "GET",
    path: "/users/all_users",
    title: "Get All Users",
    description: "Retrieves a list of all users in the system",
    purpose:
      "User list is set in client side state (genererally on page load) for various uses, including user populating user dropdowns or formatting of user first/last names via filtering by email address",
    examplePath: null,
    requiredParams: null,
    requestPayload: null,
    requestResponse: {
      firstName: "Jimmy",
      lastName: "Oliva",
      user_group: "loan_officer",
      company_name: "Cliffco Mortgage Bankers Corp",
      organization_id: "organization-live-5b1d402a-100d-4db4-a459-fba4c244a4c6",
      user_project_type: "b2b",
      emailAddress: "joliva@cliffcomortgage.com",
      phone_number: "None",
      member_id: "member-live-9cc5b3cb-af76-4a59-9f3f-8932dbac51f2",
      roles: "None",
      trusted_metadata: {
        emailAddress: "joliva@cliffcomortgage.com",
        firstName: "Jimmy",
        lastName: "Oliva",
      },
      permissions: ["admin", "underwriting", "sales_admin"],
      teams: [],
      fullName: "Jimmy Oliva",
      timezone: "America/New_York",
    },
  },
  {
    method: "GET",
    path: "/users/logged_in_user",
    title: "Get Logged In User Details",
    description: "Retrieves detailed information about the user",
    purpose: null,
    examplePath: null,
    requiredParams: null,
    requestPayload: null,
    requestResponse: [
      {
        _id: "68000b632a58928bcfa7c321",
        firstName: "James",
        lastName: "Chen",
        organization_id:
          "organization-live-5b1d402a-100d-4db4-a459-fba4c244a4c6",
        user_project_type: "b2b",
        emailAddress: "jchen@cliffcomortgage.com",
        phone_number: "+15168746572",
        member_id: "member-live-28d99540-33eb-493a-99ab-0263f69479cb",
        roles: ["loan_officer"],
        trusted_metadata: {
          emailAddress: "jchen@cliffcomortgage.com",
          firstName: "James",
          lastName: "Chen",
        },
        permissions: ["sales"],
        teams: [],
        fullName: "James Chen",
        createdDate: "2025-04-16T15:56:19.914000",
      },
      {
        _id: "67daec918a41ed8b43dd024c",
        firstName: "Chris",
        lastName: "Wolpert",
        organization_id:
          "organization-live-5b1d402a-100d-4db4-a459-fba4c244a4c6",
        user_project_type: "b2b",
        emailAddress: "dev1@cliffcomortgage.com",
        phone_number: "+15162205739",
        member_id: "member-live-aba2dddf-2acd-4b21-84ad-b900a314ab8e",
        roles: "None",
        trusted_metadata: {
          emailAddress: "dev1@cliffcomortgage.com",
          firstName: "Chris",
          lastName: "Wolpert",
        },
        permissions: ["admin", "underwriting", "sales_admin"],
        teams: [],
        fullName: "Chris Wolpert",
        createdDate: "2025-03-19T12:10:57.029000",
      },
      {
        _id: "67dac8de2f1a7bf8b92bac61",
        firstName: "Jimmy",
        lastName: "Oliva",
        name: {
          first_name: "Jimmy",
          last_name: "Oliva",
        },
        emailAddress: "joliva@cliffcomortgage.com",
        phone_number: "None",
        role: "Admin",
        trusted_metadata: {
          emailAddress: "joliva@cliffcomortgage.com",
          firstName: "Jimmy",
          lastName: "Oliva",
        },
        permissions: ["admin", "underwriting", "sales_admin"],
        teams: [],
        fullName: "Jimmy Oliva",
        stytch_user_id: "user-live-20daccd3-85d4-469e-b6ae-5c3ca3668c6a",
        member_id: "member-live-9cc5b3cb-af76-4a59-9f3f-8932dbac51f2",
      },
    ],
  },
];
